import ExtendRentalConfigModal from "./extend-rental-config-modal.component";

export default ExtendRentalConfigModal;
